import {Component} from '@angular/core';
import {Events} from 'ionic-angular';
import { NavController,ModalController } from 'ionic-angular';
import {Api} from "../../providers/api";
import {WebstoreUserAddPopup} from "../webstore-user-add-popup/webstore-user-add-popup";
import {LoginPage} from '../login/login';
import { MsgManager } from '../../providers/msg-manager';
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'webstore-user-add',
  templateUrl: 'webstore-user-add.html'
})
export class WebstoreUserAddPage{

	private showList: boolean;
	private customers:any = [];
	private searchQuery:any;




	constructor(private nav:NavController,
		private api:Api,
		private modalController:ModalController,
    private events:Events,
    private msgManager:MsgManager,
    private gVLogger: GVLogger){
		this.showList = true;
	    this.searchQuery = " ";



	      this.searchCustomersLazy(this.searchQuery,0);



	}


	searchCustomersLazy(searchQuery,itemCount){

    return new Promise(resolve=>{

      if(searchQuery === '')
      searchQuery === ' ';

    var url = "customers/searchAll/"+searchQuery+"/"+itemCount;
    this.gVLogger.log(url);
    // get list items of a category as sample
    this.api.get(url).map(res => res.json())
    .subscribe(data => {

      if(data.status == "200"){

        let temp = this.customers;

      if(!(typeof data === 'undefined') && data ){
          if (data.data && data.data.constructor === Array) {

          } else {
            data.data = [];
          }
        }else{
          data = { data: []};
        }

      for(let cust of data.data){
        //this.gVLogger.log(cust);
        if(cust.userId){
        cust.haveCreds = 1;
        }else{
        cust.haveCreds = 0;
        }
        temp.push(cust);
      }

      this.customers  = this.arrayUnique(temp);

      // this.customers = this.customers.concat(data.data);
      this.gVLogger.log(this.customers);
      resolve(true);

      }else if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }


      });

    });
}


doInfinite(infiniteScroll){
     this.searchCustomersLazy(this.searchQuery,this.customers.length).then(()=>{
       infiniteScroll.complete();
     });
}

searchThroughItems(ev: any){
    // Reset items back to all of the items
    // this.initializeCustomers();
    this.gVLogger.log(ev.target.value);
    // Show the results
    this.showList = true;
// set val to the value of the searchbar
    let val = ev.target.value;

    if(ev.target.value!=""){
      this.searchQuery = val;
      this.customers = [];
      this.searchCustomersLazy(this.searchQuery,0);
      }else{
          this.searchQuery = " ";
	      this.customers = [];
	      this.searchCustomersLazy(this.searchQuery,0);
      }


    }

    onCancel(ev) {
    this.searchQuery = " ";
      this.customers = [];
      this.searchCustomersLazy(this.searchQuery,0);
    ev.target.value = '';
  }

    arrayUnique(array) {
	    var a = array.concat();
	    for(var i=0; i<a.length; ++i) {
	        for(var j=i+1; j<a.length; ++j) {
	            if(a[i].id === a[j].id)
	                a.splice(j--, 1);
	        }
	    }

	    return a;
	}


	getRandomInt() { // 0 or 1 dummy data
	  return Math.round(Math.random()) ;
	}

	addCustomerCred(customer){
		if(customer.userStatus != 1){
			this.gVLogger.log("Add Customer Credentials");
			let modal = this.modalController.create(WebstoreUserAddPopup,{ customer: customer ,button:"CREATE"});
			modal.onDidDismiss(data => {
				if(data!=null){
					customer = data.customer;
					let callStatus = data.callStatus;
					if(callStatus == 1){
						customer.haveCreds = 1;
          this.nav.pop();
          }
        }


			});
			modal.present();
		}else{
			this.gVLogger.log("Already have creds");
		}
	}



}



// WEBPACK FOOTER //
// ./src/pages/webstore-user-add/webstore-user-add.ts